/* ============================================================
   KICA Academy product-page custom JS
   Consolidated from inline <script> tags previously embedded in
   each custom Liquid block. Event delegation + data attributes
   so the same code handles N instances and survives Shopify's
   custom-liquid sanitizer.
   ============================================================ */
(function () {
  'use strict';
  if (window.__kicaProductLoaded) return;
  window.__kicaProductLoaded = true;

  /* ---------- Countdown timers (price-combo + sale-timer) ---------- */
  function bindTimers() {
    var timers = document.querySelectorAll('[data-kica-timer]');
    timers.forEach(function (timer) {
      if (timer.dataset.kicaTimerBound === 'true') return;
      timer.dataset.kicaTimerBound = 'true';

      var endStr = timer.getAttribute('data-endtime');
      if (!endStr) return;
      var end = new Date(endStr).getTime();
      if (isNaN(end)) return;

      var daysEl = timer.querySelector('[data-timer-days]');
      var hoursEl = timer.querySelector('[data-timer-hours]');
      var minsEl = timer.querySelector('[data-timer-minutes]');
      var secsEl = timer.querySelector('[data-timer-seconds]');

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function tick() {
        var diff = end - Date.now();
        if (diff < 0) {
          timer.classList.add('timer-hidden');
          clearInterval(interval);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (daysEl) daysEl.textContent = pad(d);
        if (hoursEl) hoursEl.textContent = pad(h);
        if (minsEl) minsEl.textContent = pad(m);
        if (secsEl) secsEl.textContent = pad(s);
      }

      tick();
      var interval = setInterval(tick, 1000);
    });
  }

  /* ---------- Popup trigger (Omnisend embedded form) ---------- */
  var popupOverlay = null;

  function ensureOverlay(formId) {
    if (popupOverlay && popupOverlay.dataset.formId === formId) return popupOverlay;

    if (popupOverlay && popupOverlay.parentNode) {
      popupOverlay.parentNode.removeChild(popupOverlay);
    }

    popupOverlay = document.createElement('div');
    popupOverlay.id = 'kica-popup-overlay';
    popupOverlay.dataset.formId = formId;
    popupOverlay.innerHTML =
      '<div class="popup-content">' +
        '<span class="popup-close" aria-label="Close">&times;</span>' +
        '<div id="' + formId + '"></div>' +
      '</div>';
    document.body.appendChild(popupOverlay);

    var closeBtn = popupOverlay.querySelector('.popup-close');
    closeBtn.addEventListener('click', closePopup);
    popupOverlay.addEventListener('click', function (e) {
      if (e.target === popupOverlay) closePopup();
    });

    // Warm up the embed (Omnisend mounts on element presence)
    popupOverlay.style.display = 'flex';
    popupOverlay.style.visibility = 'hidden';
    setTimeout(function () {
      popupOverlay.style.display = 'none';
      popupOverlay.style.visibility = 'visible';
    }, 150);

    return popupOverlay;
  }

  function openPopup(formId) {
    var overlay = ensureOverlay(formId);
    overlay.style.display = 'flex';
    requestAnimationFrame(function () { overlay.classList.add('show'); });
  }

  function closePopup() {
    if (!popupOverlay) return;
    popupOverlay.classList.remove('show');
    setTimeout(function () { popupOverlay.style.display = 'none'; }, 400);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-kica-popup-form]');
    if (!trigger) return;
    var formId = trigger.getAttribute('data-kica-popup-form');
    if (formId) openPopup(formId);
  });

  /* ---------- Back-to-top button (mobile, inside sticky ATC) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kica-back-to-top]');
    if (!btn) return;
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* ---------- Init ---------- */
  function init() {
    bindTimers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
